import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { DropdownFilter, DropdownSelect, useDropdown } from 'shared/components/DropdownFilter';
import { useFilterChangeCallback, useShowSearchMetaTooltip } from 'shared/hooks';
import { selectContractFilter } from 'shared/selectors/filters/contract';
import { selectIsInlineFiltersRedesigned } from 'shared/selectors/redesigned/selectIsInlineFiltersRedesigned';
import { TSelectValue } from 'shared/types/filters';

import { EContractType } from '../../../packages/api-models/common/json_query';

import { FILTER_KEY } from './constants';

export const ContractContainer: FC = () => {
  const { label, value, options } = useSelector(selectContractFilter);
  const isFiltersRedesignEnabled = useSelector(selectIsInlineFiltersRedesigned);

  const dropdownState = useDropdown(FILTER_KEY);
  const showTooltip = useShowSearchMetaTooltip(FILTER_KEY);

  const onChange = useFilterChangeCallback(FILTER_KEY);

  const handleChange = useCallback(
    (next: TSelectValue) => {
      const nextValue = Array.isArray(next) ? (next as EContractType[]) : null;
      onChange({ action: 'setContract', arguments: [nextValue && nextValue.length ? nextValue : null] });
    },
    [onChange],
  );

  return (
    <DropdownFilter
      {...dropdownState}
      buttonLabel={label}
      showTooltip={showTooltip}
      isFiltersRedesignEnabled={isFiltersRedesignEnabled}
      dropdownContent={<DropdownSelect multiple options={options} value={value} onChange={handleChange} />}
    />
  );
};
